module.exports = __webpack_public_path__ + "img/Fb-icon.931f3cf4.svg";